/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */

import { dateUtils } from '@opengeoweb/shared';

export interface TimelineRange {
  start: Date;
  end: Date;
}

export const getTimelineRange = (
  selectedDays: readonly number[],
  now: Date = dateUtils.getNowUtc(),
): TimelineRange => {
  const dayZero = dateUtils.startOfDayUTC(now);
  const minDay = selectedDays.length ? Math.min(...selectedDays) : 0;
  const maxDay = selectedDays.length ? Math.max(...selectedDays) : 1;
  // The window starts at the earliest selected day (so a later-starting type
  // shifts the whole range) and ends at the end of the latest selected day.
  const start = dateUtils.add(dayZero, { days: minDay });
  const end = dateUtils.add(dayZero, { days: maxDay + 1 });
  return { start, end };
};
